import { DeviceDetectorService } from 'ngx-device-detector';

import { SimpleScrollerService } from './simple-scroller.service';

export const windowScrollerServiceFactory = (deviceDetector: DeviceDetectorService, windowContactUs: any) =>
  new SimpleScrollerService();
